module.exports = __webpack_public_path__ + "img/liked-posts.1b793d37.svg";